module.exports = __webpack_public_path__ + "static/media/jonathan2.068bcb05.png";